/* -------------------------------------------------------------------------------------------------
 * IPlanGridModel
 * -----------------------------------------------------------------------------------------------*/

export interface IPlanGridModel {
    _id: string;
    client: string;
    user: string;
    token: string;
    createdAt: string;
}

/* -------------------------------------------------------------------------------------------------
 * PlanGridModel
 * -----------------------------------------------------------------------------------------------*/
export class PlanGridModel {
    _id: string;
    client: string;
    user: string;
    token: string;
    createdAt: string;

    constructor(data: Partial<IPlanGridModel>) {
        this._id = data._id ?? '';
        this.client = data.client ?? '';
        this.user = data.user ?? '';
        this.token = data.token ?? '';
        this.createdAt = data.createdAt ?? '';
    }

    static fromObject(data: Partial<IPlanGridModel>): PlanGridModel {
        const model = new PlanGridModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IPlanGridModel>[]): PlanGridModel[] {
        return data.map((row) => PlanGridModel.fromObject(row));
    }

    static cloneFrom(data: Partial<IPlanGridModel>): PlanGridModel {
        const model = new PlanGridModel(data);

        return model;
    }

    toObject(): IPlanGridModel {
        const data: IPlanGridModel = {
            _id: this._id,
            client: this.client,
            user: this.user,
            token: this.token,
            createdAt: this.createdAt,
        };

        return data;
    }
}
